import { Outlet } from "react-router-dom";
import { ZendeskWidget } from "src/components/ZendeskWidget";
import { useLoggedInAppSetup } from "src/hooks/useLoggedInAppSetup";

/** Zendesk, logged-in setup, and child routes once inside `AppProviders` on a migrated URL. Layout choice is per sibling branch below. */
export function AuthenticatedShell() {
  useLoggedInAppSetup();

  return (
    <>
      <ZendeskWidget />
      <Outlet />
    </>
  );
}
